import { Component, Input } from '@angular/core';  
import { GeneralHistoryModel } from '../../../web-api-client';

@Component({
  selector: 'app-activity-feed',
  templateUrl: './activity-feed.component.html',
  styleUrls: ['./activity-feed.component.scss'],
})
export class ActivityFeedComponent {
  @Input() history: GeneralHistoryModel[] = [];

  public isCollapsed = false; 
}
